import type { PostContactRequest } from '@houzy/schemas/partner-cockpit/partner-matching';

import { contactOptionRequiresPrice } from '../labels';
import type { ContactRequestValue, OfferRequestContactOption } from '../types';
import {
    appendPriceBreakdownToContactMessage,
    type ContactRequestPriceLabels,
} from './formatContactRequestOpeningMessage';
import { parseAmount } from './parseAmount';

export function toContactRequestPayload(
    option: OfferRequestContactOption,
    value?: ContactRequestValue,
    labels?: ContactRequestPriceLabels,
): PostContactRequest {
    const grossPrice = value === undefined ? undefined : parseAmount(value.grossPrice);
    const netPrice = value === undefined ? undefined : parseAmount(value.netPrice);
    const vatRate = value === undefined ? undefined : parseAmount(value.vatRate);
    const partnerMessage = value?.message.trim() ?? '';

    const message =
        contactOptionRequiresPrice(option) &&
        grossPrice !== undefined &&
        grossPrice > 0 &&
        netPrice !== undefined &&
        vatRate !== undefined &&
        labels !== undefined
            ? appendPriceBreakdownToContactMessage(
                  partnerMessage,
                  { netPriceChf: netPrice, vatRatePercent: vatRate, grossPriceChf: grossPrice },
                  labels,
              )
            : partnerMessage;

    return {
        type: option,
        ...(message ? { message } : {}),
        ...(grossPrice !== undefined && grossPrice > 0
            ? {
                  grossPriceChf: grossPrice,
                  netPriceChf: netPrice,
                  vatRatePercent: vatRate,
              }
            : {}),
    };
}
